<script setup>
</script>

<template>
  <header class="navbar">
    <div class="logo-container">
      <img src="../assets/logo/just-eat-logo.svg" alt="logo" />
    </div>
  </header>
</template>

<style scoped>
.navbar {
  background: #FF8000;
  padding: 16px 32px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04), 0 8px 12px -2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  padding: 4px 0;
  width: 163px;
  height: 48px;
}
</style>